<template>
  <div>
    <Modal class="mask long-modal" :width="850" style="max-height:80%; over-flow:auto" v-model="isShow"
           :mask-closable="false" @on-visible-change="resetFiled"
    >
      <div slot="header" class="modal-header">添加企业合同<span>{{`房间/床位数：${roomsCount}`}}</span></div>
      <div class="specialdrop" v-if="data">
        <Form :label-width="110">
          <Row :gutter="8">
            <Col span="6">
              <FormItem label="联系人手机">
                <Input v-model="data.userPhone" disabled></Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem label="企业名称">
                <Input v-model="data.signName" disabled></Input>
              </FormItem>
            </Col>
            <Col span="10">
              <FormItem :label-width="106" label="企业地址">
                <Input v-model="data.businessAddress"></Input>
              </FormItem>
            </Col>
          </Row>
          <Row :gutter="16">
            <Col span="6">
              <FormItem label="联系人">
                <Input v-model="data.contactsName"></Input>
              </FormItem>
            </Col>
            <Col span="8">
              <FormItem label="联系人邮箱">
                <Input v-model="data.contactsMail"></Input>
              </FormItem>
            </Col>
            <Col span="10" class="flex">
<!--              <FormItem :label-width="110" label="联系人身份证号">-->
<!--                <Input v-model="data.contactsIdcard"  ></Input>-->
<!--              </FormItem>-->
              <FormItem  class="flexnone" :label-width="90" label="代理人证件号">

                <Select style="width: 100px" v-model="data.contactsIdcardType"  >
                  <div v-if="createContractData">
                    <Option v-for="item in createContractData.contacterTypeEnum" :value="item.value" :key="item.value">
                      {{item.text}}
                    </Option>

                  </div>

                </Select>
              </FormItem>

              <FormItem :label-width="1"   class="flexauto">
                <Input v-model="data.contactsIdcard"   style="width: 100%;display: block"></Input>
              </FormItem>
            </Col>
          </Row>
          <Row :gutter="8">
            <Col span="7">
              <div class="flex">
                <FormItem :label-width="1">
                  <Select v-model="data.businessQualificationType" style="width: 78px" class="flexnone"
                          >
                    <Option v-for="item in companyBusinessQualificationTypeList" :value="item.code" :key="item.code">
                      {{item.name}}
                    </Option>
                  </Select>
                  <Input v-model="data.businessQualification"  ></Input>
                </FormItem>
              </div>
            </Col>
          </Row>
          <Row :gutter="8">
            <Col span="14">
              <div class=" ivu-form-item " v-if="data.businessLicenseList">
                <span style="width:82px;" class="inline-b ivu-form-item-label"
                      v-if="data.businessQualificationType === 1">营业执照</span>
                <span style="width:82px;" class="inline-b ivu-form-item-label"
                      v-if="data.businessQualificationType === 3">法人证书</span>
                <div>
                  <div class="upload-wrap" v-for="(item,index) in data.businessLicenseList" :key="'keyG'+index">
                    <!--@click="showImg()"-->
                    <img class="imgwidth" :src="item.attachmentImgUrl"/>
                    <Upload
                      :action="baseUrl+'/file/uploadFile'"
                      :data="{type:index}"
                      :on-success="handleSuccess"
                      :headers="{'Access-Token':token}"
                      :show-upload-list="false"
                      :on-error="handleError"
                      :format="['jpg','jpeg','png']"
                      :on-format-error="formatError"
                    >
                      <a href="javascript:;">修改</a>
                    </Upload>
                  </div>
                  <div class="upload-wrap" v-if="data.businessLicenseList.length == 0">
                    <!-- <img class="imgwidth" :src="data.businessLicenseList[0].attachmentImgUrl"/> -->
                    <Upload
                      :action="baseUrl+'/file/uploadFile'"
                      :data="{type:1}"
                      :on-success="handleSuccess"
                      :headers="{'Access-Token':token}"
                      :show-upload-list="false"
                      :on-error="handleError"
                      :format="['jpg','jpeg','png']"
                      :on-format-error="formatError"
                    >
                      <a href="javascript:;">请上传企业资质证明</a>
                    </Upload>
                  </div>
                </div>
              </div>
            </Col>
            <Col span="10">
              <div class=" ivu-form-item " v-if="data.grantAuthList&&data.grantAuthList.length>0">
                <span style="width:115px;" class="inline-b ivu-form-item-label">租房事务委托书</span>
                <div class="upload-wrap" v-for="(item,index) in data.grantAuthList" :key="'keyF'+index">
                  <img class="imgwidth" :src="item.attachmentImgUrl"/>
                  <Upload
                    :action="baseUrl+'/file/uploadFile'"
                    :data="{type:index}"
                    :on-success="handleSuccess2"
                    :headers="{'Access-Token':token}"
                    :show-upload-list="false"
                    :on-error="handleError"
                    :format="['jpg','jpeg','png']"
                    :on-format-error="formatError"
                  >
                    <a href="javascript:;">修改</a>
                  </Upload>
                </div>
              </div>

              <div class=" ivu-form-item " v-if="data.grantAuthList.length == 0 ">
                <span style="width:115px;" class="inline-b ivu-form-item-label">租房事务委托书</span>
                <div class="upload-wrap">
                  <Upload
                    :action="baseUrl+'/file/uploadFile'"
                    :data="{type:1}"
                    :on-success="handleSuccess2"
                    :headers="{'Access-Token':token}"
                    :show-upload-list="false"
                    :on-error="handleError"
                    :format="['jpg','jpeg','png']"
                    :on-format-error="formatError"
                  >
                    <a href="javascript:;">请上传租房事务委托书</a>
                  </Upload>
                </div>
              </div>
            </Col>
          </Row>
        </Form>
        <Form :model="rentData" :label-width="82" :rules="formRules1" ref="calculatePriceForm"
              v-if="createContractData">
          <div class="box">
            <Row :gutter="16">
              <Col span="10">
                <FormItem label="租期方式" prop="rentType">
                  <Select v-model="rentData.rentType" @on-change="changeRentType">
                    <Option v-for="(item,index) in createContractData.leaseTime" :value="item.value"
                            :key="'keyA'+index">
                      {{item.text}}
                    </Option>
                  </Select>
                </FormItem>
              </Col>
            </Row>
            <Row :gutter="16">
              <Col span="24">
                <FormItem label="租期时间" prop="">
                  <Row>
                    <Col span="8" style="width:158px; padding-left:0; padding-right:0">
                      <DatePicker type="date" v-model="conEndDate"></DatePicker>
                    </Col>
                    <Col span="8" style="width:164px; padding-left:8px; padding-right:0">
                      <FormItem prop="conEndDate" style="">
                        <DatePicker v-if="rentData.rentType === 1" type="date"
                                    v-model="rentData.conEndDate" :options="options1" placeholder="退租日"
                                    @on-change="choosePayment"></DatePicker>
                        <DatePicker type="date"
                                    v-if="rentData.rentType === 2" :start-date="options2.minTime"
                                    v-model="rentData.conEndDate" :options="options2" placeholder="退租日"
                                    @on-change="choosePayment"></DatePicker>
                        <DatePicker v-if="rentData.rentType===0" v-model="rentData.conEndDate"
                                    @on-change="choosePayment"></DatePicker>

                      </FormItem>
                    </Col>
                    <Col span="8">
                      <div class="time-box" v-if="rentData.rentType === 1 && year ">{{year}}年</div>
                      <div class="time-box" v-if="rentData.rentType === 2 && monthAndDay.month">{{monthAndDay.month}}月
                      </div>
                      <div class="time-box" v-if="rentData.rentType ===2 && monthAndDay.day">{{monthAndDay.day}}天</div>
                    </Col>
                  </Row>
                </FormItem>
              </Col>
            </Row>
            <Row :gutter="16">
              <Col span="10">
                <FormItem label="付款方式" prop="conCycleCode">
                  <Select v-model="rentData.conCycleCode" @on-change="calcuatePrice(0)">
                    <Option value="" v-if="!(rentData.rentType+'') || !rentData.conEndDate ">请先选择租期方式与租期时间</Option>
                    <Option v-for="(item,index) in payTypeList" :value="item.value" :key="'keyB'+index">{{item.text}}
                    </Option>
                  </Select>
                </FormItem>
              </Col>
            </Row>
            <FormItem label="请选择优惠券" v-if="couponInfoList.length">
              <section style="flex-wrap: wrap" class="flex">
                <div :class="['coupon',!item.isCheck?'nocheck':'',]"
                     v-for="item in couponInfoList"
                     @click.stop="clickCard(item)"
                >
                  <div class="flex top">
                    <div class="flexauto" style="margin-bottom: 12px">
                      <div class="name">{{item.cardName}}</div>
                      <div class="desc">{{item.description}}</div>
                    </div>
                    <div class="flexnone money">
                      {{'￥'+item.couponAmount}}
                    </div>

                  </div>
                  <div class="date" style="margin-top: 6px">{{item.subDescription}}</div>
                </div>
              </section>
            </FormItem>
          </div>
          <div class="box">
            <Row :gutter="16" class="activty-wrap">
              <Col span="15">
                <div>
                  <div class=" ivu-form-item ">
                    <span style="width:150px;" class="inline-b ivu-form-item-label">标准月租金：</span>
                    <Input class="item" v-model="price.originRentPrice" >
                      <span slot="append">元/月</span>
                    </Input>
                  </div>
                  <div class="ivu-form-item ">
                    <span style="width:150px;" class="inline-b ivu-form-item-label">实际月租金：</span>
                    <Input class="item" v-model="price.rentPrice" >
                      <span slot="append">元/月</span>
                    </Input>
                  </div>
                  <div class="ivu-form-item ">
                    <span style="width:150px;" class="inline-b ivu-form-item-label">标准服务费：<Icon class="sup-icon"
                                                                                                type="ios-help-outline"></Icon></span>
                    <Input class="item" v-model="price.originServicePrice" >
                      <span slot="append">元</span>
                    </Input>
                  </div>
                  <div class="ivu-form-item ">
                    <span style="width:150px;" class="inline-b ivu-form-item-label">实际服务费：</span>
                    <Input class="item" v-model="price.servicePrice" >
                      <span slot="append">元</span>
                    </Input>
                  </div>
                  <div class="ivu-form-item ">
                <span style="width:150px;" class="inline-b ivu-form-item-label">标准押金：<Icon class="sup-icon"
                                                                                           type="ios-help-outline"></Icon></span>
                    <Input class="item" v-model="price.originDepositPrice" >
                      <span slot="append">元</span>
                    </Input>
                  </div>
                  <div class="ivu-form-item ">
                    <span style="width:150px;" class="inline-b ivu-form-item-label">实际押金：</span>
                    <Input class="item" v-model="price.depositPrice" >
                      <span slot="append">元</span>
                    </Input>
                  </div>
                </div>
              </Col>
              <Col span="9" v-if="discounts">
                <div class="activity">
                  <div class="activity-item" v-for="(item,i) in discounts" :key="`item-${i}`">
                    <h4>{{item.name}}</h4>
                    <div>
                      <p v-for="(discountsItem,index) in item.details" :key="`discountsItem-${index}`">
                        {{`${discountsItem.name}：${discountsItem.count}`}}</p>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Form>
        <billing-details :n="billingKey" :isRead="isRead"
                         :tableData="paymentTermsDtos" :roomsCount="roomsCount"
                         :totalMoney="price.totalMoney"
                         :data="data"
                         :rentData="rentData"
                         :conStartDate="conEndDate"
                         :roomIds="roomIds"
                         :parentContractFid="parentContractFid"
                         :projectFid="projectFid"
                         @done="done"
                         :cardIds="cardIds"
        ></billing-details>
      </div>
      <div slot="footer">
        <div>
          <Button type="text" size="large" @click="checkBilling">账单明细</Button>
          <Button type="primary" size="large" @click.stop="ok">
            <span>创建合同</span>
          </Button>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script type="text/ecmascript-6">
  import {formatDateTime} from "@/utils/format";
  import {calculatePrice, getSignSubject} from "api/contractList";
  import BillingDetails from './BillingDetails'
  import {deepClone} from "../../../../utils/format";
  import {choosePayment} from "../../../../api/contractList";
  // import {getBaseUrl} from "@/utils/public";
  // import {getToken} from "@/utils/auth";
  import {getBaseUrl} from "../../../../utils/public";
  import {getToken} from "../../../../utils/auth";
  import {getQualificationChooses} from "api/enterprisecontract";

  export default {
    created() {
      this.baseUrl = getBaseUrl()
      this.token = getToken()
      getQualificationChooses().then(res => {
        res.data && (this.companyBusinessQualificationTypeList = res.data)
      }).catch(error => {
      })
    },
    name: '',
    props: {
      list: {
        type: Array,
        default: () => {
          return []
        }
      },
      parentContractFid: {
        type: String,
        default: ''
      },
      conEndDateOri: {
        type: Number,
        default: 0,
      },
      n: {
        type: Number,
        default: 0
      },
      contractFid: {
        type: String,
        default: ''
      },
      projectFid: {
        type: String,
        default: ''
      },
      roomsCount: {
        type: Number,
        default: 0
      },
      roomIds: {
        type: String,
        default: ''
      },
      createContractDataOri: {
        type: Object,
        default: null
      }
    },
    watch: {
      n() {
        this.cleanData()
        this.getSignSubject()
        this.isShow = true
      },
      createContractDataOri(value) {
        this.createContractData = deepClone(value)
      },
      conEndDateOri(value) {
        this.conEndDate = new Date(new Date(value).valueOf() + 86400000)
      }
    },
    components: {
      BillingDetails
    },
    data() {
      return {
        cardIds: [],
        couponInfoList: [],
        baseUrl: '',
        token: '',
        conEndDate: new Date(new Date(this.conEndDateOri).valueOf() + 86400000),
        createContractData: deepClone(this.createContractDataOri),
        data: null,
        billingKey: 0,
        isRead: true,
        isShow: false,
        stockMaxSignDate: 0, // 最大签约日
        year: 0,
        rentData: {
          conCycleCode: '', // 付款方式：1 月付 3 季付 6 半年付 12 年付 9 一次性付清 ,
          conEndDate: '',
          rentType: '',
        },
        validateProxy: true,
        companyQualificationList: [],
        payTypeList: [],
        formRules1: {
          conCycleCode: [{required: true, message: '请选择付款方式', trigger: 'change', type: 'string'}],
          conEndDate: [{required: true, message: ' ', trigger: 'change', type: 'object'}],
          rentType: [{required: true, message: '请选择租期方式', trigger: 'change', validator: this.validateNumber}]
        },
        price: {
          depositPrice: '', //实际押金
          originDepositPrice: '',// 标准押金
          originRentPrice: '', // 标准房租
          originServicePrice: '', // 标准服务费
          rentPrice: '', // 实际房租
          servicePrice: '', // 实际服务费
          totalMoney: 0, // 总金额
        },
        discounts: null,
        paymentTermsDtos: [],
        companyBusinessQualificationTypeList: []
      };
    },
    computed: {
      monthAndDay() {
        let ret = {
          month: '',
          day: ''
        }
        if (!this.conEndDate || !this.rentData.conEndDate || (this.conType === 1)) {
          return ret
        }
        let year1 = this.conEndDate.getFullYear()
        let month1 = this.conEndDate.getMonth()
        let day1 = this.conEndDate.getDate()
        let year2 = this.rentData.conEndDate.getFullYear()
        let month2 = this.rentData.conEndDate.getMonth()
        let day2 = this.rentData.conEndDate.getDate()
        let lasttmonthdays = new Date(year2, month2, 0).getDate()
        let diffM = month2 - month1
        let diffD = day2 - day1

        if (year1 === year2) {
          if (diffD >= 0) {
            ret.day = diffD + 1
            ret.month = month2 - month1
          } else if (diffD === -1) {
            ret.day = 0
            ret.month = diffM
          } else {
            ret.day = diffD + lasttmonthdays + 1
            ret.month = diffM - 1
          }
        } else {
          if (diffD >= 0) {
            ret.day = diffD + 1
            ret.month = diffM + 12
          } else if (diffD === -1) {
            ret.day = 0
            ret.month = diffM + 12

          } else {
            ret.day = diffD + lasttmonthdays + 1
            ret.month = diffM + 12 - 1
          }
        }
        return ret
      },
      options1() {
        if (!this.createContractData) {
          return {}
        }
        let shortcuts = []
        let year = this.conEndDate.getFullYear()
        let month = this.conEndDate.getMonth()
        let date = this.conEndDate.getDate()
        let min = this.createContractData.roomCanRent.minRentYear
        let max = this.createContractData.roomCanRent.maxRentYear
        let stockMaxSignDate = this.createContractData.roomCanRent.stockMaxSignDate
        let _this = this

        for (let i = min; i <= max; i++) {
          // console.log(year+i,month+1,date-1)
          let num1 = (new Date(year + i, month, date - 1)).valueOf()
          if (num1 > Number(stockMaxSignDate)) {
            break;
          }
          shortcuts.push({
            text: i + '年',
            value() {
              return (year + i) + '-' + (month + 1) + '-' + (date - 1)
            },
            onClick: (picker) => {
              _this.year = i
            }
          })
        }
        return {
          shortcuts: shortcuts,
          disabledDate() {
            return true
          }
        }

      },
      options2() {
        if (!this.createContractData) {
          return {}
        }
        let max = this.createContractData.roomCanRent.maxRentDay
        let min = this.createContractData.roomCanRent.minRentDay
        let stockMaxSignDate = Number(this.createContractData.roomCanRent.stockMaxSignDate)

        let minTime = this.conEndDate.valueOf() + 3600 * 24 * 1000 * (min - 1)
        let maxTime = this.conEndDate.valueOf() + 3600 * 24 * 1000 * (max - 1)
        minTime = minTime > stockMaxSignDate ? stockMaxSignDate : minTime
        maxTime = maxTime > stockMaxSignDate ? stockMaxSignDate : maxTime

        return {
          disabledDate(date) {
            return date && date.valueOf() < minTime || date.valueOf() > maxTime;
          },
          minTime: new Date(minTime)
        }
      }
    },
    methods: {
      handleError() {
        this.$Message.error('文件上传失败')
      },
      handleSuccess2(res) {
        let index = Number(res.data.type)
        if(this.data.grantAuthList.length > 0) {
          this.data.grantAuthList[index].attachmentImgUrl = res.data.url
          this.data.grantAuthList[index].fid = res.data.fid
        } else{
          this.data.grantAuthList.push({
            attachmentImgUrl:res.data.url,
            fid:res.data.fid
          })
        }
      },
      handleSuccess(res) {
        let index = Number(res.data.type)
        if(this.data.businessLicenseList.length > 0){
          this.data.businessLicenseList[index].attachmentImgUrl = res.data.url
          this.data.businessLicenseList[index].fid = res.data.fid
        } else{
          this.data.businessLicenseList.push({
            attachmentImgUrl:res.data.url,
            fid:res.data.fid
          })
        }
      },
      formatError() {
        this.$Message.error('请输入jpg,jpeg,png,格式的文件')
      },
      resetPayTypeAndValue() {
        this.rentData.conCycleCode = ''
        this.price = {
          depositPrice: '', //实际押金
          originDepositPrice: '',// 标准押金
          originRentPrice: '', // 标准房租
          originServicePrice: '', // 标准服务费
          rentPrice: '', // 实际房租
          servicePrice: '', // 实际服务费
          totalMoney: 0, // 总金额
        }
        this.discounts = null
        this.paymentTermsDtos = []

        this.couponInfoList = []

      },
      format(data) {
        if (!data) {
          return ''
        }
        return formatDateTime(data, false)

      },
      resetFiled(value) {
        if (!value) {
          this.cleanData()
          // this.$refs['calculatePriceForm'] && this.$refs['calculatePriceForm'].resetFields()
        }
      },
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      cleanData() {
        this.rentData = {
          conCycleCode: '', // 付款方式：1 月付 3 季付 6 半年付 12 年付 9 一次性付清 ,
          conEndDate: '',
          rentType: '',
        }
        this.price = {
          depositPrice: '', //实际押金
          originDepositPrice: '',// 标准押金
          originRentPrice: '', // 标准房租
          originServicePrice: '', // 标准服务费
          rentPrice: '', // 实际房租
          servicePrice: '', // 实际服务费
          totalMoney: 0, // 总金额
        }
        this.discounts = null
        this.$refs['calculatePriceForm'] && this.$refs['calculatePriceForm'].resetFields()
      },
      choosePayment() {
        this.resetPayTypeAndValue()
        if (!this.rentData.conEndDate || !(this.rentData.rentType + '') || !this.conEndDate) {
          return
        }
        let params = {
          "conEndDate": this.format(this.rentData.conEndDate),
          "conStartDate": this.format(this.conEndDate),
          "projectFid": this.projectFid,
          "rentType": this.rentData.rentType
        }
        choosePayment(params).then(res => {
          res.data && (this.payTypeList = res.data)
        }).catch(error => {
        })
      },
      validateNumber(rule, value, callback) {
        let pattern = /^\d+$/
        if (!pattern.test(value)) {
          callback(new Error('请输入正确数字'));
        }
        callback();
      },
      getSignSubject() {
        let params = {
          parentContractFid: this.parentContractFid
        }
        getSignSubject(params).then(res => {
          if (!res.data) {
            this.$Message.info('获取信息失败')
            this.isShow = false
            return
          }
          if (!res.data.customerUid) {
            this.$Message.info('该用户未注册，请先去app完成注册认证')
            this.isShow = false
            return
          }
          res.data && (this.data = res.data)
        }).catch(error => {
        })
      },
      changeRentType(value) {
        if (value === 0) {
          this.rentData.conEndDate = new Date(this.createContractData.roomCanRent.stockMaxSignDate)
          this.choosePayment()
        } else {
          this.rentData.conEndDate = ''
          this.payTypeList = []

        }
        this.resetPayTypeAndValue()
        this.year = 0
      },
      clickCard(item) {
        this.couponInfoList.forEach(ele => {
          ele.cardId !==item.cardId &&( ele.isCheck=0)
        })
        item.isCheck = item.isCheck === 0 ? 1 : 0
        this.calcuatePrice(1)

      },
      calcuatePrice(type) {
        this.$refs['calculatePriceForm'].validate(bool => {
          if (bool) {

            let params = {
              "conCycleCode": this.rentData.conCycleCode,
              "conEndDate": this.format(this.rentData.conEndDate),
              "conStartDate": this.format(this.conEndDate),
              "contractType": 1,
              "customerUid": this.data.customerUid,
              "projectFid": this.projectFid,
              "rentType": this.rentData.rentType,
              "stockFid": this.roomIds,
              "subjectType": 3,
              contractVos: this.list,
              type: type
            }

            let cardIds = []
            this.couponInfoList.forEach(ele => {
              ele.isCheck && cardIds.push(ele.cardId)
            })
            params['cardIds'] = cardIds

            calculatePrice(params).then(res => {
              if (!res.data) {
                return
              }
              this.price.depositPrice = res.data.depositPrice
              this.price.originDepositPrice = res.data.originDepositPrice
              this.price.originRentPrice = res.data.originRentPrice
              this.price.originServicePrice = res.data.originServicePrice
              this.price.rentPrice = res.data.rentPrice
              this.price.servicePrice = res.data.servicePrice
              this.price.totalMoney = res.data.totalMoney
              this.discounts = res.data.discounts
              this.paymentTermsDtos = res.data.paymentTermsDtos
              this.paymentTermsDtos = res.data.paymentTermsDtos ? res.data.paymentTermsDtos : []

              if (this.paymentTermsDtos.length === 1) {
                this.couponInfoList = this.paymentTermsDtos[0].couponShowInfoVos ? this.paymentTermsDtos[0].couponShowInfoVos : []
              }


            }).catch(error => {
            })
          }
        })


      },
      checkBilling() {
        this.$refs['calculatePriceForm'].validate(bool => {
          if (bool) {
            this.isRead = true
            this.billingKey++
          } else {
            this.changeLoading()
          }
        })
      },
      ok() {
        this.$refs['calculatePriceForm'].validate(bool => {
          if (bool) {
            this.isRead = false

            let cardIds = []
            this.couponInfoList.forEach(ele => {
              ele.isCheck && cardIds.push(ele.cardId)
            })
            this.cardIds = cardIds
            this.billingKey++
          }
          this.changeLoading()
        })
      },
      done() {
        this.$emit('done')
        this.isShow = false
      },
      handleFormatError() {
        this.$Message.error('请输入jpg,jpeg,png,格式的文件')
      },
    },

  }
</script>

<style lang="css" scoped>
  .width200 {
    width: 200px;
  }

  .box {
    padding-top: 24px;
    border-top: 1px solid #DDDEE1;
  }

  .imgwidth {
    width: 167px;
    height: 118px;
  }

  a {
    color: #CFA868;
  }

  .upload {
    display: inline-block;
  }

  .upload-wrap {
    display: inline-block;
    line-height: 1;
    padding: 10px 4px;
  }

  .ivu-date-picker {
    width: 100%;
  }

  .time-box {
    margin-left: 8px;
    display: inline-block;
    padding-left: 8px;
    padding-right: 8px;
    line-height: 30px;
    border: 1px solid #DDDEE1;
    border-radius: 2px;
  }

  .item {
    width: 200px;
  }

  .sup-icon {
    position: relative;
    top: -8px;
  }

  .activty-wrap {
    display: flex;
    align-items: center;
  }

  .activity-item {
    display: flex;
    line-height: 24px;
    margin-bottom: 12px;
  }

  .activity-item h4 {
    width: 80px;
    margin-right: 20px;
    text-align: right;
  }

  .activity-item p {
    color: #CFA868;
  }

  .upload {
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: #DDDEE1;
    width: 167px;
    height: 118px;
    border: 1px dashed rgb(220, 220, 220);
    box-sizing: border-box;
    text-align: center;
  }

  .ivu-upload {
    width: 120px;
    position: relative;
  }

  .ivu-upload a {
    position: absolute;
    right: 0;
  }

  .upload.error {
    border-color: #F56356;
  }

</style>
